/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import Grid from "@material-ui/core/Grid";

//custom library
import { AddOrderComment, DisplayOrderComment } from "./";
import { Paper } from "../components";

export default function OrderComment(props: any) {
  const {
    saveChange,
    orderHandleChange,
    cancelChange,
    inputComment,
    orderComment,
  } = props;
  return (
    <Paper>
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <AddOrderComment
            {...{
              saveChange,
              orderHandleChange,
              cancelChange,
              inputComment,
            }}
          />
        </Grid>
        <Grid item>
          <DisplayOrderComment {...{ orderComment }} />
        </Grid>
      </Grid>
    </Paper>
  );
}
